/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";

// Allowed extensions for images and documents.
export const allowedImageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
export const allowedDocumentExtensions = ["doc", "docx", "pdf", "txt", "rtf", "odt", "xls", "xlsx", "ppt", "pptx", "csv"];

export const getExtension = (filename) => {
    const dot_index = filename.lastIndexOf(".");
    const length = filename.length;
    const ext = filename.substring(dot_index+1, length);
    return ext.toLowerCase();
};

export const getBasenameAndExtension = (filename) => {
    const dot_index = filename.lastIndexOf(".");
    const length = filename.length;
    const basename = filename.substring(0, dot_index);
    let ext = filename.substring(dot_index+1, length).toLowerCase();
    ext = ext.toLowerCase();
    return [basename, ext];
};

export const isValidImageExtension = (ext) => {
    return allowedImageExtensions.includes(ext);
};

export const isValidDocumentExtension = (ext) => {
    return allowedDocumentExtensions.includes(ext);
};

export const isKnownFileType = (file) => {
    const allowed_object = Config.Documents.accept;
    const allowed_types = Object.keys(allowed_object);
    const type = file.type;
    // const passes = allowed_types.hasOwnProperty(type)
    const passes = allowed_types.includes(type);
    return passes;
};
export const isFileTypeInSet = (file, allowed) => {
    const allowed_types = Object.keys(allowed);
    const type = file.type;
    // const passes = allowed_types.hasOwnProperty(type);
    const passes = allowed_types.includes(type);
    return passes;
};
